import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { storeResourceCredentials, getToken } from "../../../api/apps";
import Loader from "../Loader/Loader";
import {decodeResourceParams,encodeResourceParams} from "../../../utils/urlEncoder";
import {
  AppBar,
  Toolbar,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
} from "@mui/material";

const PromptForCredentialsPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const decodedData = decodeResourceParams(params.get('data'));
  const assetId = decodedData?.assetId;
  const systemUserId = decodedData?.systemUserId;
  const resourceType = decodedData?.resource_type;
  const appType = decodedData?.app_type;
  const policyId = decodedData?.policy_id;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Detect if this is a database-gui request
  const isDatabaseGUI = resourceType === "apps" && appType;

  if (!assetId || !systemUserId) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6">
          Invalid access. Missing asset or user info.
        </Typography>
      </Box>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const credentialType = isDatabaseGUI ? null : "sftp";
    const { data, error } = await storeResourceCredentials(username, password, credentialType);

    if (data && data.token) {
      const promttoken = data.token;
      const { tokenData, tokenError } = await getToken();
      setLoading(false);
      if (tokenData) {
        let url = "";

        if (isDatabaseGUI) {
          const params = {
            resource_id: assetId,
            systemuser_id: systemUserId,
            resource_type: "apps",
            app_type: appType,
            token_key: tokenData.token_key || "",
            token_value: tokenData.token_value || "",
            prompt_for_credential: promttoken || "",
          };
          if (policyId) {
            params.policy_id = policyId;
          }
          const encodedData = encodeResourceParams(params);
          url =
            window.location.protocol +
            "//" +
            window.location.host +
            "/pam/database-gui" +
            "/?data=" +
            encodedData;
        } else {
          // Redirect to file_manager for SFTP with encoded params
          const params = {
            resource_id: assetId,
            systemuser_id: systemUserId,
            resource_type: "assets",
            token_key: (tokenData.token_key || ""),
            token_value: (tokenData.token_value || ""),
          }
          if (policyId) {
            params.policy_id = policyId;
          }
          const encodedData = encodeResourceParams(params);
          url = "/pam/file_manager/?data=" + encodedData +
            "&prompt_key_credentials=" +
            (promttoken || "");
        }
        window.location.href = url;
      } else {
        setError(tokenError || "Could not get session token");
      }
    } else {
      setLoading(false);
      setError(error || "Invalid credentials");
    }
  };

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar position="fixed">
        <Toolbar sx={{ py: 1.5 }}>
          <Typography
            variant="h6"
            sx={{ flexGrow: 1, alignItems: "center", justifyContent: "center" }}
          >
            Enter Resource Credentials
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mt: 8,
        }}
      >
        <Loader loading={loading} />
        <Paper
          component="form"
          onSubmit={handleSubmit}
          elevation={2}
          sx={{
            p: 3,
            width: "100%",
            maxWidth: 400,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <TextField
            fullWidth
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
            variant="outlined"
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            variant="outlined"
          />
          {error && (
            <Typography color="error" textAlign="center">
              {error}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            sx={{ mt: 1 }}
          >
            Submit
          </Button>
        </Paper>
      </Box>
    </Box>
  );
};

export default PromptForCredentialsPage;
